module.exports = __webpack_public_path__ + "img/aParty_111523_E.05f0b186.jpg";